import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IonicPage } from 'ionic-angular';

/**
 * Generated class for the GdToastPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'gd-toast',
  templateUrl: 'gd-toast.html',
})
export class GdToastPage {

  @Input() title:any = 'mantab';
  @Input() desc:any = 'mantab';
  @Input() ctaLabel:any = 'mantab';

  @Output() callback = new EventEmitter();

  constructor() {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GdToastPage');
  }

  action(){
    this.callback.emit();
  }

}



// WEBPACK FOOTER //
// ./src/components/gd-toast/gd-toast.ts